import React from 'react';

import RichTextEditorContent from '../../RichTextEditor/components/RichTextEditorContent';

import styles from './Resume.module.scss';

const resumeClassNames = {
  container: styles.resumeEditorContainer,
  sectionTitle: styles.sectionTitle,
  paragraph: styles.paragraph,
  unorderedList: styles.unorderedList,
  unorderedListItem: styles.unorderedListItem,
  resumeContactHeader: styles.resumeContactHeader,
  resumeContactHeader_DocumentResumeName: styles.resumeContactHeader_DocumentResumeName,
  resumeContactHeader_DocumentResumeHeadline: styles.resumeContactHeader_DocumentResumeHeadline,
  resumeContactHeader_DocumentResumeAddressLine: styles.resumeContactHeader_DocumentResumeAddressLine,
  resumeContactHeader_DocumentResumePhone: styles.resumeContactHeader_DocumentResumePhone,
  resumeContactHeader_DocumentResumeEmail: styles.resumeContactHeader_DocumentResumeEmail,
  resumeEntryDateRange: styles.resumeEntryDateRange,
  resumeEntryTitle: styles.resumeEntryTitle,
};

const ResumeRichTextEditor = ({
  setState,
  state,
  contentEditable,
}) => {
  return (
    <RichTextEditorContent
      state={state}
      setState={setState}
      contentEditable={contentEditable}
      classNames={resumeClassNames}
    />
  );
};

export default ResumeRichTextEditor;
